(function () {
    const GIFT_5_VARIANT_ID = 58123677761884;
    const GIFT_10_VARIANT_ID = 58123788124508;

    const GIFT_PRODUCT_HANDLES = [
        'free-exclusive-pet-tapes-5-pcs',
        'free-exclusive-pet-tapes-10-pcs'
    ];

    const THRESHOLD_5_EUR = 10000;
    const THRESHOLD_10_EUR = 20000;

    const PROMO_START = new Date('2026-06-23T09:00:00+03:00');
    const PROMO_END = new Date('2026-06-29T00:00:00+03:00');

    let isUpdatingGift = false;

    function isPromoActive() {
        const now = new Date();
        return now >= PROMO_START && now < PROMO_END;
    }

    function isGiftVariantId(variantId) {
        return Number(variantId) === GIFT_5_VARIANT_ID || Number(variantId) === GIFT_10_VARIANT_ID;
    }

    function isGiftItem(item) {
        return isGiftVariantId(item.variant_id);
    }

    function cartHasOnlyGifts(cart) {
        return cart.items.length > 0 && cart.items.every(isGiftItem);
    }

    function getCurrencyRate() {
        if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
            return parseFloat(Shopify.currency.rate);
        }

        return 1;
    }

    function convertPresentmentCentsToEurCents(cents) {
        const rate = getCurrencyRate();

        if (!rate || rate <= 0) {
            return cents;
        }

        return Math.round(cents / rate);
    }

    function hideBirthdayPromoBanner() {
        document.querySelectorAll('.birthday-promo-banner').forEach(function (banner) {
            banner.style.display = 'none';
        });
    }

    function showBirthdayPromoBanner() {
        document.querySelectorAll('.birthday-promo-banner').forEach(function (banner) {
            banner.style.display = 'block';
        });
    }

    function hideBirthdayGiftBar() {
        const bar = document.querySelector('birthday-gift-bar');

        if (bar) {
            bar.style.display = 'none';
        }
    }

    function showBirthdayGiftBar() {
        const bar = document.querySelector('birthday-gift-bar');

        if (bar) {
            bar.style.display = '';
        }
    }

    function disableGiftQuickViewTriggers() {
        document.querySelectorAll('quick-view-trigger[data-url]').forEach(function (trigger) {
            const url = trigger.getAttribute('data-url') || '';

            const isGiftQuickView = GIFT_PRODUCT_HANDLES.some(function (handle) {
                return url.includes('/products/' + handle);
            });

            if (!isGiftQuickView) return;

            trigger.style.display = 'none';
            trigger.setAttribute('aria-disabled', 'true');
            trigger.removeAttribute('tabindex');
            trigger.style.pointerEvents = 'none';
        });
    }

    function disableGiftProductPagePurchase() {
        const giftVariantIds = [
            String(GIFT_5_VARIANT_ID),
            String(GIFT_10_VARIANT_ID)
        ];

        const variantParams = document
            .querySelector('shopify-accelerated-checkout')
            ?.getAttribute('variant-params') || '';

        const productForm = document.querySelector('form[action*="/cart/add"]');
        const variantInput = productForm?.querySelector('[name="id"]');
        const currentVariantId = variantInput ? variantInput.value : '';

        const appstleProductData = document
            .querySelector('.appstle_membership_stand_alone_selector')
            ?.getAttribute('data-product-data') || '';

        const currentPath = window.location.pathname || '';

        const isGiftProductPage =
            isGiftVariantId(currentVariantId) ||
            giftVariantIds.some(function (id) {
                return variantParams.includes(id) || appstleProductData.includes(id);
            }) ||
            GIFT_PRODUCT_HANDLES.some(function (handle) {
                return currentPath.includes('/products/' + handle);
            });

        if (!isGiftProductPage) return;

        document.querySelectorAll('button[name="add"]').forEach(function (button) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            button.classList.add('disabled');
            button.style.pointerEvents = 'none';

            const label = button.querySelector('.button__inner, .button-label');

            if (label) {
                label.textContent = 'Promotional Gift Only';
            } else {
                button.textContent = 'Promotional Gift Only';
            }
        });

        document.querySelectorAll(
            'checkout-dynamic-buttons, .shopify-payment-button, shopify-accelerated-checkout, shop-pay-wallet-button, more-payment-options-link, .main-product__view-details'
        ).forEach(function (el) {
            el.style.display = 'none';
        });

        document.querySelectorAll('.product-form__quantity, quantity-input').forEach(function (el) {
            el.style.display = 'none';
        });
    }

    async function getCart() {
        const response = await fetch('/cart.js');
        return await response.json();
    }

    async function addGift(variantId) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: {
                    _birthday_gift: 'true'
                }
            })
        });
    }

    async function removeLine(lineKey) {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
                id: lineKey,
                quantity: 0
            })
        });
    }

    function getSubtotalWithoutGiftsInEur(cart) {
        const giftTotal = cart.items
            .filter(isGiftItem)
            .reduce((sum, item) => sum + item.final_line_price, 0);

        const totalAfterDiscountsWithoutGifts = cart.total_price - giftTotal;

        return convertPresentmentCentsToEurCents(totalAfterDiscountsWithoutGifts);
    }

    function formatMoney(cents) {
        return `€${(cents / 100).toFixed(2)}`;
    }

    function renderBirthdayGiftBar(subtotalEur) {
        const bar = document.querySelector('birthday-gift-bar');
        if (!bar) return;

        showBirthdayGiftBar();

        const message = bar.querySelector('.birthday-gift-message');
        const progress = bar.querySelector('.progress');

        if (!message || !progress) return;

        const gift5Title = bar.dataset.gift5Title || '5 free PET Tapes';
        const gift10Title = bar.dataset.gift10Title || '10 free PET Tapes';

        let text = '';
        let progressPercent = 0;

        if (subtotalEur < THRESHOLD_5_EUR) {
            const left = THRESHOLD_5_EUR - subtotalEur;

            text = `Spend <span class="price medium-weight">${formatMoney(left)}</span> more to unlock <span class="medium-weight">${gift5Title}</span>!`;
            progressPercent = Math.min((subtotalEur / THRESHOLD_5_EUR) * 100, 100);
        } else if (subtotalEur < THRESHOLD_10_EUR) {
            const left = THRESHOLD_10_EUR - subtotalEur;

            text = `You've unlocked <span class="medium-weight">${gift5Title}</span>! Spend <span class="price medium-weight">${formatMoney(left)}</span> more to unlock <span class="medium-weight">${gift10Title}</span>!`;
            progressPercent = Math.min((subtotalEur / THRESHOLD_10_EUR) * 100, 100);
        } else {
            text = `Congratulations! You've unlocked <span class="medium-weight">${gift10Title}</span>!`;
            progressPercent = 100;
        }

        message.innerHTML = text;
        progress.style.setProperty('--progress', `${Math.round(progressPercent)}%`);
    }

    async function updateBirthdayGift() {
        if (isUpdatingGift) return;

        isUpdatingGift = true;

        try {
            const cart = await getCart();

            const gift5 = cart.items.find(item => item.variant_id === GIFT_5_VARIANT_ID);
            const gift10 = cart.items.find(item => item.variant_id === GIFT_10_VARIANT_ID);

            if (cartHasOnlyGifts(cart)) {
                hideBirthdayGiftBar();

                if (gift5) await removeLine(gift5.key);
                if (gift10) await removeLine(gift10.key);

                document.dispatchEvent(new CustomEvent('birthdayGift:updated'));
                return;
            }

            if (!isPromoActive()) {
                hideBirthdayGiftBar();
                hideBirthdayPromoBanner();

                if (gift5) await removeLine(gift5.key);
                if (gift10) await removeLine(gift10.key);

                document.dispatchEvent(new CustomEvent('birthdayGift:updated'));
                return;
            }

            showBirthdayPromoBanner();

            const subtotalWithoutGiftsEur = getSubtotalWithoutGiftsInEur(cart);

            renderBirthdayGiftBar(subtotalWithoutGiftsEur);

            let cartWasChanged = false;

            if (subtotalWithoutGiftsEur >= THRESHOLD_10_EUR) {
                if (gift5) {
                    await removeLine(gift5.key);
                    cartWasChanged = true;
                }

                if (!gift10) {
                    await addGift(GIFT_10_VARIANT_ID);
                    cartWasChanged = true;
                }
            } else if (subtotalWithoutGiftsEur >= THRESHOLD_5_EUR) {
                if (gift10) {
                    await removeLine(gift10.key);
                    cartWasChanged = true;
                }

                if (!gift5) {
                    await addGift(GIFT_5_VARIANT_ID);
                    cartWasChanged = true;
                }
            } else {
                if (gift5) {
                    await removeLine(gift5.key);
                    cartWasChanged = true;
                }

                if (gift10) {
                    await removeLine(gift10.key);
                    cartWasChanged = true;
                }
            }

            if (cartWasChanged) {
                window.location.reload();
                return;
            }

            document.dispatchEvent(new CustomEvent('birthdayGift:updated'));
        } catch (error) {
            console.error('Birthday gift update failed:', error);
        } finally {
            isUpdatingGift = false;
        }
    }

    function scheduleBirthdayGiftUpdate() {
        setTimeout(updateBirthdayGift, 400);
        setTimeout(updateBirthdayGift, 1000);
        setTimeout(updateBirthdayGift, 1800);
    }

    document.addEventListener('DOMContentLoaded', function () {
        disableGiftQuickViewTriggers();
        disableGiftProductPagePurchase();
        updateBirthdayGift();
    });

    document.addEventListener('cart:updated', updateBirthdayGift);
    document.addEventListener('ajaxCart:updated', updateBirthdayGift);
    document.addEventListener('cart-drawer:updated', updateBirthdayGift);
    document.addEventListener('cart:change', updateBirthdayGift);
    document.addEventListener('cart:refresh', updateBirthdayGift);

    document.addEventListener('click', function (event) {
        const target = event.target.closest(
            'button, a, input, quick-view-trigger, .quantity-input__button, cart-remove-button'
        );

        if (!target) return;

        scheduleBirthdayGiftUpdate();
        setTimeout(disableGiftProductPagePurchase, 800);
        setTimeout(disableGiftQuickViewTriggers, 800);
    });

    document.addEventListener('change', function (event) {
        const target = event.target;

        if (!target.matches('.quantity-input__input, input[name="updates[]"]')) {
            return;
        }

        scheduleBirthdayGiftUpdate();
    });

    document.addEventListener('input', function (event) {
        const target = event.target;

        if (!target.matches('.quantity-input__input, input[name="updates[]"]')) {
            return;
        }

        scheduleBirthdayGiftUpdate();
    });

    window.updateBirthdayGift = updateBirthdayGift;
})();